<template>
  <div class="view search">
    <div class="header">
      <div class="content title">{{ $t('headerSearchAddCompany') }}</div>
      <div class="content">
        <div class="input-container">
          <input v-model="inputSearchCompany" type="text" :placeholder="$t('companySearchPlaceholder')" class="input" @keydown.enter="getCompany" />
          <div class="icon-container"><IconSearch class="icon-search" @click="getCompany" /></div>
        </div>

        <div v-if="user.isMainUser" class="main-button" @click="$router.push('/importCompanies')">
          <IconImport class="icon icon-import"></IconImport>{{ $t('import') }}
        </div>
      </div>
    </div>

    <div v-if="!id || error.state" class="content sub">
      <div class="sub-header">
        <div
          v-for="link in searchMenu"
          :key="link.id + companies"
          class="link"
          :class="{ active: selectedSearchMenu === link.id }"
          @click="
            scrollTop();
            reverseMenu(link);
          "
        >
          {{ link.title }} ({{
            link.id === 'enterprise-search'
              ? `${getInfos.totalCompanies || getInfos.totalCompaniesNoRcs + getInfos.totalCompaniesRcs + getInfos.totalRadieCompanies === 0 ? getInfos.totalCompaniesNoRcs + getInfos.totalCompaniesRcs + getInfos.totalRadieCompanies : '–'}`
              : `${getInfos.totalExecutive || getInfos.totalExecutive === 0 ? getInfos.totalExecutive : '–'}`
          }})
        </div>
      </div>

      <div v-if="selectedSearchMenu === 'enterprise-search'" class="info">
        <div class="line">
          <span>{{
            getInfos.totalCompanies || getInfos.totalCompaniesNoRcs + getInfos.totalCompaniesRcs + getInfos.totalRadieCompanies === 0
              ? getInfos.totalCompaniesNoRcs + getInfos.totalCompaniesRcs + getInfos.totalRadieCompanies
              : '–'
          }}</span>
          {{ $t('companiesMatch') }}
        </div>
        <div class="line">
          {{ $t('include') }}
          <span>{{ (getInfos && getInfos.totalCompaniesRcs) || getInfos.totalCompaniesRcs === 0 ? getInfos.totalCompaniesRcs : '–' }}</span>
          {{ $t('rcsCompanies') }},
          <span>{{ getInfos.totalCompaniesNoRcs || getInfos.totalCompaniesNoRcs === 0 ? getInfos.totalCompaniesNoRcs : '–' }}</span>
          {{ $t('notRcsCompanies') }}<span>{{ getInfos.totalRadieCompanies || getInfos.totalRadieCompanies === 0 ? getInfos.totalRadieCompanies : '–' }}</span>
          {{ $t('radieRcsCompanies') }}
        </div>
      </div>

      <div v-else class="info">
        <div class="line">
          <span>{{ getInfos.totalExecutive === '–' ? '–' : getInfos.totalExecutive }}</span> {{ $t('executivesMatch') }}
        </div>
      </div>

      <SearchTable
        ref="searchTableEntreprise"
        :headers="
          selectedSearchMenu === 'enterprise-search'
            ? [$t('companyLabel'), $t('address'), $t('registration'), $t('activity')]
            : [$t('executive'), $t('companyLabel'), $t('address'), $t('registration')]
        "
        :error="error"
        :searched-text="inputSearchCompany"
        :is-executive="selectedSearchMenu === 'manager-search'"
        :set-executive="setExecutive"
        @get-date="updateInfos"
      />
    </div>

    <div v-else-if="!loading && company && !error.state" class="content sub">
      <GeneralInfo :set-monitored="setMonitored" :company="company" />

      <a v-if="!isMonitoredLoading" id="btn-sub-header" class="margin-link" style="opacity: 0; height: 0; width: 0" href="#sub-header"></a>

      <div v-if="!isMonitoredLoading" id="sub-header" class="sub-header no-scroll-bar">
        <RouterLink
          v-for="link in menu"
          :key="link.id"
          :class="{
            active: page.includes(link.id),
            disabled: !link.enabled && !isMonitored,
          }"
          :to="link.enabled || isMonitored ? link.id : `enterprise`"
          class="link"
          @click.stop="link.enabled || isMonitored ? scrollTop : $store.dispatch('setPopup', { popupType: 'HaveToMonitor' })"
        >
          <span v-if="!(link.enabled || isMonitored)">
            <IconLock class="icon-lock"></IconLock>
          </span>
          <span>{{ link.title }}</span>
        </RouterLink>
      </div>

      <RouterView v-if="!isMonitoredLoading" :company="company" :is-monitored="isMonitored"></RouterView>
    </div>

    <div v-else class="content sub line">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {{ loading ? $t('searchInProgress') : $t('noCompanies') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GeneralInfo from '@/components/search/GeneralInfo';
import SearchTable from '@/components/tables/SearchTable';

export default {
  components: { SearchTable, GeneralInfo },

  beforeRouteUpdate(to, from, next) {
    if (from.name.includes('By') && to.query.q) {
      this.inputSearchCompany = to.query.q;
      this.getCompany(to.query.q);
    }

    next();
  },

  props: {
    searchedCompanies: {
      type: String,
      required: false,
      default: '',
    },

    id: {
      required: false,
      type: String,
      default: () => '',
    },

    page: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedSearchMenu: 'enterprise-search',
      searchMenu: [
        { id: `enterprise-search`, title: `${this.$t('companies')} ` },
        { id: `manager-search`, title: 'Dirigeants ' },
      ],
      menu: [
        { id: `enterprise`, enabled: true, title: this.$t('searchMenu.recap') },
        { id: `people`, enabled: false, title: this.$t('searchMenu.people') },
        { id: `documents`, enabled: false, title: this.$t('searchMenu.documents') },
        { id: `alerts`, enabled: false, title: this.$t('searchMenu.alerts') },
        { id: `notes`, enabled: false, title: this.$t('searchMenu.note') },
      ],
      selectedMenu: 'enterprise',
      companies: {},
      isMonitored: false,
      isMonitoredLoading: true,
      inputSearchCompany: '',
      loading: true,
      scrollEvent: null,
      company: {},
      error: {
        state: false,
        errorMessage: '',
      },
      forceUpdate: 0,
      getInfos: {},
      searchedCompaniesInternal: '',
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),

    getExecutiveSearchCount() {
      if (!this.companies || !this.companies.executivesSearch) return '–';
      if (this.companies.executivesSearch.executiveCount === 0) return 0;
      return this.$utils.splitStringBySegmentLength(this.companies.executivesSearch.executiveCount);
    },
  },

  watch: {
    async id(newValue) {
      if (newValue) {
        this.loading = true;
        try {
          this.isMonitored = false;
          const result = await this.$store.dispatch('getCompanyInfo', { searchedCompanySiren: newValue });
          this.error.state = false;
          this.error.errorMessage = '';
          this.company = result;
          this.loading = false;
        } catch {
          this.companies = {};
          this.company = {};
          this.loading = false;
          this.error.errorMessage = this.$t('anErrorOccured');
          this.error.state = true;
        }
      }
    },
  },

  async mounted() {
    this.searchedCompaniesInternal = this.searchedCompanies;

    setTimeout(async () => {
      if (this.$route.query.q) {
        this.inputSearchCompany = this.$route.query.q;
        this.getCompany(this.$route.query.q);
      } else if (this.$route.params.searchedCompanies) {
        this.inputSearchCompany = this.$route.params.searchedCompanies;
        this.getCompany(this.$route.params.searchedCompanies);
      } else if (this.searchedCompaniesInternal) {
        this.inputSearchCompany = this.searchedCompaniesInternal;
        this.getCompany(this.searchedCompaniesInternal);
      } else if (this.inputSearchCompany) {
        this.getCompany(this.inputSearchCompany);
        this.searchedCompaniesInternal = this.inputSearchCompany;
      }
      if (this.id) {
        this.loading = true;
        this.error.state = false;
        this.error.errorMessage = '';
        try {
          this.company = await this.$store.dispatch('getCompanyInfo', { searchedCompanySiren: this.$route.params.id });
          this.loading = false;
        } catch {
          this.companies = {};
          this.company = {};
          this.loading = false;
          this.error.state = true;
          this.error.errorMessage = this.$t('anErrorOccured');
        }
      }

      if (!this.searchedCompaniesInternal && !this.id && !this.$route.params.searchedCompanies) this.loading = false;
    }, 200);
  },

  methods: {
    async reverseMenu(link) {
      this.selectedSearchMenu = link.id;
    },

    setMonitored(val) {
      this.isMonitored = val;
      this.isMonitoredLoading = false;
    },

    async getCompany() {
      if (this.inputSearchCompany.trim().length === 0) return;

      const isSiren = Number(this.inputSearchCompany.replace(/\s/g, ''));
      if (isSiren && isSiren.toString().length >= 6) {
        this.inputSearchCompany = this.inputSearchCompany.replace(/\s/g, '');
      }

      this.$router.push({
        name: 'search',
        params: { searchedCompanies: this.inputSearchCompany },
        query: { q: this.inputSearchCompany },
      });

      this.forceUpdate = this.forceUpdate + 1;
      this.setExecutive(false);
      if (this.id && !this.error.state) this.$router.push({ name: 'search', params: { searchedCompanies: this.inputSearchCompany } });
      else if (this.id && this.error.state) this.$router.push({ name: this.$route.matched[this.$route.matched.length - 2].name });

      if (this.$refs['searchTableEntreprise']) this.$refs['searchTableEntreprise'].resetMixin();
    },

    scrollTop() {
      const url = location.href;
      location.href = '#' + 'sub-header';
      history.replaceState(null, null, url);
    },

    setExecutive(bool) {
      this.selectedSearchMenu = bool ? 'manager-search' : 'enterprise-search';
    },

    updateInfos() {
      this.forceUpdate;
      if (this.selectedSearchMenu !== 'enterprise-search') {
        if (!this.$refs['searchTableEntreprise']) return {};
        this.getInfos = this.$refs['searchTableEntreprise'].getSearchInfos();
      } else {
        if (!this.$refs['searchTableEntreprise']) return {};
        this.getInfos = this.$refs['searchTableEntreprise'].getSearchInfos();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  box-sizing: border-box;

  .input {
    width: 100%;
    height: 48px;
    margin: 0 0 16px;
    padding: 12px 16px;
    box-sizing: border-box;
    color: colors.$text-color;
    border: solid 1px colors.$lightgrey-color;
    border-radius: 4px;
    background: colors.$white-color;

    &:last-child {
      margin: 0;
    }

    &::placeholder {
      color: colors.$lightgrey-color;
    }

    &.incorrect {
      border-color: colors.$error-color;
    }
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 128px 0 50px;
    background: colors.$main-color;

    .title {
      width: 100%;
      font-weight: 500;
      font-size: 20px;
      text-align: left;
      color: colors.$white-color;
      display: flex;
      justify-content: flex-start;
      margin: 0 0 16px;
    }

    .input-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      margin: 0 32px 0 0;
      box-sizing: border-box;

      .icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 46px;
        padding: 0;
        color: colors.$lightblue-color;
        border-radius: 4px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border: solid 1px colors.$lightgrey-color;
        background: colors.$white-color;
        border-left: none;

        &:hover {
          cursor: pointer;

          .icon-search {
            transform: scale(1.1);
          }
        }
      }

      .input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
        padding-right: 0;
        margin: 0;
        text-overflow: ellipsis;
      }
    }

    .main-button {
      background: colors.$lightgreen-color;
      min-width: 48px;
      padding: 0 18px;
      border-radius: 5px;

      .icon {
        margin-right: 6px;
      }
    }
  }

  .content {
    &.sub {
      display: flex;
      padding: 80px 0 0;
      flex-direction: column;

      &.line {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: colors.$main-color;

        .lds-ring {
          margin-right: 24px;
        }
      }

      .margin-link {
        margin: 80px 0 0;
      }
    }

    .sub-header {
      position: sticky;
      top: 0;
      background: colors.$white-color;
      margin: 0;
      z-index: 101;
      display: flex;
      padding: 0;

      .link {
        width: fit-content;
        white-space: nowrap;

        &.disabled {
          display: flex;
          align-items: center;
          cursor: not-allowed;
          color: rgba(colors.$grey-color, 0.9);

          .icon-lock {
            opacity: 0.48;
            margin: 0 4px 0 0;
            transform: scale(0.6);
          }

          &:hover {
            opacity: 1;
          }
        }
      }
    }

    .info {
      margin: 20px 0 0;
      width: 100%;
      display: flex;
      flex-direction: column;

      .line {
        font-size: 14px;
        color: colors.$lightblue-color;

        span {
          font-weight: 800;
        }
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .content.sub {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .sub-header {
    overflow-x: auto;
  }
}
</style>
